<template>
    <a href="https://www.google.com/maps/place/Sovtes,+LLC/@50.4689603,30.4621578,16z/data=!4m5!3m4!1s0x0:0xcc27e81b6812c47d!8m2!3d50.4688257!4d30.4621588">
       <img class="map" alt="" title="Перейти на карту" :src="require(`@/assets/img/map.png`)">
    </a>
</template>

<script>

    import { GOOGLE_KEY } from "@/libs/constants";

    export default { 
        name: "VMap",
        data: function(){
            return{
                mapKey : GOOGLE_KEY
            }
        }
    }

</script>

<style lang="scss" scoped>
    .map{
        margin-left: 20px;
        border: 0;
        width: 500px;
        height: 450px;
        cursor: pointer;
    }
</style>

<style scoped>
@media (max-width: 600px){
    .map{
        border: 0;
        width: 400px;
        height: 342px;
        margin-left: 0;
    }
}

@media (max-width: 414px){
    .map{
        border: 0;
        width: 380px;
        height: 230px;
        margin-left: 0;
    }
}

@media (max-width: 375px){
    .map{
        border: 0;
        width: 350px;
        height: 210px;
        margin-left: 0;
    }
}

@media (max-width: 360px){
    .map{
        /* корректно отображается до ширины в 315 px */
        width: 300px;
    
    }
}


</style>